import { Injectable } from "@angular/core";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";

@Injectable()

export class SecurityReviewService extends BaseService {
    public CompareList: any[];
    public selectedInvoiceId: number;
}